import { render, staticRenderFns } from "./HeartIcon.vue?vue&type=template&id=3eccb569&lang=pug&"
import script from "./HeartIcon.vue?vue&type=script&lang=js&"
export * from "./HeartIcon.vue?vue&type=script&lang=js&"
import style0 from "./HeartIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports